import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createPromise } from 'redux-promise-middleware';
import { routerMiddleware } from 'connected-react-router';

import { createReduxEnhancer } from '@sentry/react';
import history from './history';
import { ErrorMiddleware } from '../store/middlewares';
import createRootReducer from '../store/reducers';
import { isProduction, isDebugEnabled, ENABLE_SENTRY } from './secrets';
const enableDebug = !isProduction || isDebugEnabled || false;

const sentryReduxEnhancer = createReduxEnhancer({});

function configureStore(preloadedState?: {} | undefined) {
  const composeEnhancer = enableDebug ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const middleware = [
    thunk.withExtraArgument({}),
    ErrorMiddleware,
    createPromise({
      promiseTypeSuffixes: ['loading', 'success', 'error'],
      promiseTypeDelimiter: ':',
    }),
    routerMiddleware(history),
  ];

  const enhancers = [applyMiddleware(...middleware)];

  if (ENABLE_SENTRY) {
    enhancers.push(sentryReduxEnhancer);
  }

  const store = createStore(createRootReducer(history), preloadedState, composeEnhancer(...enhancers));

  // Hot reloading
  if ((module as any).hot) {
    // Enable Webpack hot module replacement for reducers
    (module as any).hot.accept('../store/reducers', () => {
      store.replaceReducer(createRootReducer(history));
    });
  }

  return store;
}

const store = configureStore();

// export { configureStore };

export default store;
